export const REF_USER_PARAM = "ref_user";
export const SHARE_ID_PARAM = "share_id";
export const SHARE_SOURCE_PARAM = "share_source";
export const SHARE_ACTION_SOURCE = "share_action";
export const URL_COPY_SOURCE = "url_copy";

export type ShareSource = typeof SHARE_ACTION_SOURCE | typeof URL_COPY_SOURCE;

export type ShareAttribution = {
  shareId: string;
  shareSource: typeof SHARE_ACTION_SOURCE;
};

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function createShareId(): string {
  return crypto.randomUUID();
}

export function isValidShareId(value: string | null | undefined): value is string {
  return typeof value === "string" && UUID_PATTERN.test(value);
}

export function buildExplicitShareUrl(input: string, userExternalId: string, shareId: string): string {
  const url = new URL(input, window.location.href);

  if (userExternalId) {
    url.searchParams.set(REF_USER_PARAM, userExternalId);
  } else {
    url.searchParams.delete(REF_USER_PARAM);
  }
  url.searchParams.set(SHARE_SOURCE_PARAM, SHARE_ACTION_SOURCE);
  url.searchParams.set(SHARE_ID_PARAM, shareId);

  return url.toString();
}

export function buildDirectUrlParams(input: URLSearchParams, userExternalId: string): URLSearchParams {
  const params = new URLSearchParams(input);
  params.delete(SHARE_ID_PARAM);
  params.set(SHARE_SOURCE_PARAM, URL_COPY_SOURCE);
  params.set(REF_USER_PARAM, userExternalId);
  return params;
}

export function readShareAttribution(input: URLSearchParams): {
  ref_user?: string;
  share_id?: string;
  share_source?: ShareSource;
} {
  const attribution: {
    ref_user?: string;
    share_id?: string;
    share_source?: ShareSource;
  } = {};
  const refUser = input.get(REF_USER_PARAM);
  const shareId = input.get(SHARE_ID_PARAM);
  const shareSource = input.get(SHARE_SOURCE_PARAM);

  if (refUser) attribution.ref_user = refUser;
  if (shareSource === SHARE_ACTION_SOURCE || shareSource === URL_COPY_SOURCE) {
    attribution.share_source = shareSource;
  }
  if (shareSource === SHARE_ACTION_SOURCE && isValidShareId(shareId)) attribution.share_id = shareId;

  return attribution;
}
